import { displayAr } from "../../pages/Catalog/catalogUi";

const PALETTES = [
  "bg-zinc-900 text-white",
  "bg-indigo-800 text-white",
  "bg-emerald-900 text-white",
  "bg-rose-900 text-white",
  "bg-amber-900 text-white",
];

function hashLabel(text) {
  let hash = 0;
  for (const ch of text) hash = (hash * 33 + ch.charCodeAt(0)) >>> 0;
  return hash;
}

export function caseStyleLabel(name) {
  const label = displayAr(name);
  if (!name || !label || label === "—") return "شفاف";
  return label;
}

export function CaseStyleBadge({ name, usesTypeStock = false, className = "", textClass = "text-[10px]" }) {
  const label = caseStyleLabel(name);
  const quiet = usesTypeStock || !name;
  const tone = quiet
    ? "bg-white text-slate-700 ring-1 ring-slate-300"
    : PALETTES[hashLabel(label) % PALETTES.length];
  return (
    <span className={`inline-flex max-w-full items-center truncate rounded px-1.5 py-0.5 font-bold ${textClass} ${tone} ${className}`}>
      {label}
    </span>
  );
}

export function PersonalizedBadge({ className = "" }) {
  return (
    <span className={`inline-flex items-center rounded bg-fuchsia-600 px-1.5 py-0.5 text-[10px] font-bold text-white ${className}`}>
      باسم
    </span>
  );
}
